import { StringObject } from "../../objects/StringObject";
import { StringModule } from "../../core/StringModule";
import { StringContext } from "../../core/StringContext";

export class StringVideoAutoplay extends StringModule {
  constructor(context: StringContext) {
    super(context);
    this.htmlKey = "autoplay";

    this.attributesToMap = [
      ...this.attributesToMap,
      {
        key: "src",
        type: "string",
        fallback: "",
      },
    ];
  }

  onObjectConnected(object: StringObject) {
    object.setProperty("onEnterEvent", this.onEnterObject.bind(this));
    object.events.on(
      "enter",
      object.getProperty<(object: StringObject) => void>("onEnterEvent")
    );
    object.setProperty("onLeaveEvent", this.onLeaveObject.bind(this));
    object.events.on(
      "leave",
      object.getProperty<(object: StringObject) => void>("onLeaveEvent")
    );

    const videoElement = object.htmlElement as HTMLVideoElement;
    const started =
      this.tools.domAttribute.process({
        element: videoElement,
        key: "string-started",
        fallback: null,
      }) !== null;

    if (videoElement.tagName.toLowerCase() === "video" && !started) {
      videoElement.setAttribute("string-started", "");
      videoElement.muted = true;
      videoElement.setAttribute("muted", "muted");
      videoElement.setAttribute("playsinline", "");
      videoElement.setAttribute("loop", "");
      videoElement.setAttribute("autoplay", "");
      videoElement.src = object.getProperty("src");
      videoElement.load();
      videoElement.addEventListener("canplay", () => {});
    }
  }

  private onEnterObject(object: StringObject) {
    const videoElement = object.htmlElement as HTMLVideoElement;
    this.tryPlay(videoElement);
  }
  private onLeaveObject(object: StringObject) {
    const videoElement = object.htmlElement as HTMLVideoElement;
    videoElement.pause();
  }

  private tryPlay(element: HTMLVideoElement) {
    element
      .play()
      .catch((err) =>
        console.warn("[StringVideoAutoplay] Autoplay failed:", err)
      );
  }
}
